import dateFormatType from '@/constants/dateFormatType';
import { storeBaromoneyFieldPack, storeBaromoneyLocalePack, } from '@/constants/salesFieldPack';
import { sortNumber } from '@/utils/sort';
import { beforeDays, beforeMonths } from '@/utils/time';
import { format } from 'date-fns';
import AbsSales from './AbsSales';
/**
 * 상점 바로머니 (일별, 월별 통합)
 */
export default class StoreBaromoney extends AbsSales {
    resourceType = 'store';
    dateType = 'daily';
    date = [];
    graphName = '';
    graphSubTitle = '';
    graphCaptureName = '';
    isGraphConfig = false;
    excelFileName = '상점 바로머니';
    excelSheetName = 'Sheet1';
    excelCellWidth = [
        12,
        20,
        20,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        16,
        12,
        12,
    ];
    excelHeaderData = [
        [
            storeBaromoneyLocalePack.id,
            storeBaromoneyLocalePack.hubName,
            storeBaromoneyLocalePack.storeName,
            storeBaromoneyLocalePack.storeType,
            storeBaromoneyLocalePack.date,
            storeBaromoneyLocalePack.cacheClosingBalance,
            storeBaromoneyLocalePack.cacheSettlementTotal,
            storeBaromoneyLocalePack.cacheCharge,
            storeBaromoneyLocalePack.withdrawalAmount,
            storeBaromoneyLocalePack.deliveryCommission,
            storeBaromoneyLocalePack.deliveryAmount,
            storeBaromoneyLocalePack.orderChannelCommission,
            storeBaromoneyLocalePack.orderChannelAmountCommission,
            storeBaromoneyLocalePack.smsCacheDeduction,
            storeBaromoneyLocalePack.other,
        ],
    ];
    excelMergeData = [];
    pageHeaderData = [
        {
            title: storeBaromoneyLocalePack.id,
            value: storeBaromoneyFieldPack.id,
            align: 'center',
            cellAlign: 'ta-c',
            width: 80,
            sortable: true,
            sortLogic: sortNumber,
        },
        {
            title: storeBaromoneyLocalePack.hubName,
            value: storeBaromoneyFieldPack.hubName,
            align: 'center',
            cellAlign: 'ta-c',
            width: 200,
            sortable: true,
            sortLogic: sortNumber,
        },
        {
            title: storeBaromoneyLocalePack.storeName,
            value: storeBaromoneyFieldPack.storeName,
            align: 'center',
            cellAlign: 'ta-c',
            width: 200,
            sortable: true,
            sortLogic: sortNumber,
        },
        {
            title: storeBaromoneyLocalePack.storeType,
            value: storeBaromoneyFieldPack.storeType,
            align: 'center',
            cellAlign: 'ta-c',
            width: 80,
            sortable: true,
            sortLogic: sortNumber,
        },
        {
            title: storeBaromoneyLocalePack.date,
            value: storeBaromoneyFieldPack.date,
            align: 'center',
            cellAlign: 'ta-c',
            width: 80,
            sortable: true,
            sortLogic: sortNumber,
        },
        {
            title: storeBaromoneyLocalePack.cacheClosingBalance,
            value: storeBaromoneyFieldPack.cacheClosingBalance,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.cacheSettlementTotal,
            value: storeBaromoneyFieldPack.cacheSettlementTotal,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.cacheCharge,
            value: storeBaromoneyFieldPack.cacheCharge,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.withdrawalAmount,
            value: storeBaromoneyFieldPack.withdrawalAmount,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.deliveryCommission,
            value: storeBaromoneyFieldPack.deliveryCommission,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.deliveryAmount,
            value: storeBaromoneyFieldPack.deliveryAmount,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.orderChannelCommission,
            value: storeBaromoneyFieldPack.orderChannelCommission,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.orderChannelAmountCommission,
            value: storeBaromoneyFieldPack.orderChannelAmountCommission,
            align: 'center',
            cellAlign: 'ta-c',
            width: 150,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.smsCacheDeduction,
            value: storeBaromoneyFieldPack.smsCacheDeduction,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
        {
            title: storeBaromoneyLocalePack.other,
            value: storeBaromoneyFieldPack.other,
            align: 'center',
            cellAlign: 'ta-c',
            width: 100,
            sortable: true,
            sortLogic: sortNumber,
            isTotal: 'sum',
        },
    ];
    // eslint-disable-next-line class-methods-use-this
    makeGraphConfig() { }
    /**
     * 초기화 날짜 생성
     * @returns 초기화 날짜
     */
    initDate(type = 'daily') {
        if (type === 'daily') {
            this.date = [
                format(beforeDays(new Date(), 1), dateFormatType.DATE),
                format(new Date(), dateFormatType.DATE),
            ];
        }
        else {
            this.date = [
                format(beforeMonths(new Date(), 1), dateFormatType.MONTH),
                format(new Date(), dateFormatType.MONTH),
            ];
        }
    }
}
